import { AppBar, Link, Typography } from '@mui/material'

var footerText = "Questions? Email audrey@losknits.com"

export default function Footer() {
  return (
    <AppBar 
      position="static" 
      sx={{ 
        bgcolor: "#F6F1E7",
        minHeight: 24,
        display: "flex",
        justifyContent: "center",
        px: 2
      }}
    >
      <Typography variant="caption">
        <Link href="mailto:audrey@losknits.com">{footerText}</Link>
      </Typography>
    </AppBar>
  )
}
